import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M4 17l5 1l.75 -1.5","key":"svg-1"}],["path",{"d":"M15 21l0 -4l-4 -3l1 -6","key":"svg-2"}],["path",{"d":"M7 12l0 -3l5 -1l3 3l3 1","key":"svg-3"}]]

const IconRun = createReactComponent('outline', 'run', 'Run', __iconNode);

export default IconRun;